/**
 * Video-Section: Autoplay beim Sichtbarwerden (Desktop + Mobile).
 */
(function () {
  const SECTION_MEDIA = '[data-rf-video-section-autoplay], [data-rf-slideshow-video-autoplay]';

  function prepareVideo(video) {
    if (!video || video.dataset.rfPrepared === 'true') return;
    video.dataset.rfPrepared = 'true';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.controls = false;
    video.disablePictureInPicture = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.removeAttribute('controls');
    video.setAttribute('controlsList', 'nodownload nofullscreen noremoteplayback');
  }

  function playVideo(video) {
    if (!video) return;
    prepareVideo(video);
    const attempt = () => {
      const promise = video.play();
      if (promise?.catch) promise.catch(() => {});
    };
    if (video.readyState >= 2) attempt();
    else {
      video.addEventListener('loadeddata', attempt, { once: true });
      video.addEventListener('canplay', attempt, { once: true });
    }
  }

  function pauseVideo(video) {
    if (!video || video.paused) return;
    try {
      video.pause();
    } catch (e) {
      /* ignore */
    }
  }

  function initMedia(media) {
    if (!media || media.dataset.rfVideoInit === 'true') return;
    media.dataset.rfVideoInit = 'true';

    const video = media.querySelector('video');
    if (!video) return;

    const syncVisible = () => {
      const rect = media.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1) return;
      const visible = Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);
      const ratio = visible / Math.max(rect.width, 1);

      if (ratio >= 0.35) playVideo(video);
      else pauseVideo(video);
    };

    video.addEventListener('pause', () => {
      if (!media.contains(video) || !video.paused) return;
      window.setTimeout(() => {
        if (!video.paused) return;
        const rect = media.getBoundingClientRect();
        if (rect.width < 1 || rect.height < 1) return;
        const visible = Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);
        const ratio = visible / Math.max(rect.width, 1);
        if (ratio >= 0.35 && document.visibilityState === 'visible') playVideo(video);
      }, 200);
    });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => syncVisible());
      resizeObserver.observe(media);
    }

    requestAnimationFrame(syncVisible);
    window.setTimeout(syncVisible, 150);
    window.setTimeout(syncVisible, 500);
    window.addEventListener('load', syncVisible, { once: true });
    window.addEventListener('pageshow', syncVisible);

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.35) playVideo(video);
            else pauseVideo(video);
          });
        },
        { threshold: [0, 0.35, 0.5, 0.75, 1] }
      );
      observer.observe(media);
    } else {
      window.addEventListener('scroll', () => window.requestAnimationFrame(syncVisible), { passive: true });
    }
  }

  function init(scope) {
    const root = scope?.nodeType === 1 ? scope : document;
    root.querySelectorAll(SECTION_MEDIA).forEach(initMedia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
